import React from 'react';
import * as styles from './slashlist.module.scss';

export function Component({ content, className }) {
  return (
    <div className={className}>
      <ul className={styles.list}>
        {content && (
          <ul className={styles.technologies}>
            {content.map(listItem => (
              <li className={styles.technologiesItem} key={listItem}>
                {listItem}
              </li>
            ))}
          </ul>
        )}
      </ul>
    </div>
  );
}
